export default __webpack_public_path__ + "static/media/slide10.489d02b6.jpg";